import { SVGIcon } from '@progress/kendo-angular-icons';
import { arrowDownIcon, arrowRotateCcwIcon, arrowsRotateOutlineIcon, arrowsSwapIcon, arrowUpIcon, buildingsSolidIcon, calendarIcon, cancelIcon, caretAltLeftIcon, caretAltRightIcon, checkboxNullIcon, checkIcon, chevronDownIcon, chevronLeftIcon, chevronRightIcon, chevronUpIcon, clockArrowRotateIcon, copyIcon, downloadIcon, editToolsIcon, exclamationCircleIcon, exportIcon, fileExcelIcon, filePdfIcon, filterClearIcon, folderOpenIcon, fullscreenIcon, gearIcon, gearsIcon, homeIcon, hyperlinkOpenIcon, infoCircleIcon, mapMarkerIcon, menuIcon, minusCircleIcon, minusIcon, moreHorizontalIcon, pasteSparkleIcon, pencilIcon, plusCircleIcon, plusIcon, questionSolidIcon, redoIcon, reorderIcon, saveIcon, searchIcon, stickyNoteIcon, tableColumnInsertLeftIcon, tableRowInsertAboveIcon, trashIcon, undoIcon, uploadIcon, userIcon, warningTriangleIcon, windowIcon, xCircleIcon, xIcon, zoomInIcon, zoomOutIcon, zoomSparkleIcon } from '@progress/kendo-svg-icons';

export const kendoIcons = {
  arrowUp: arrowUpIcon,
  arrowDown: arrowDownIcon,
  attention: exclamationCircleIcon,
  buildings: buildingsSolidIcon,
  calendar: calendarIcon,
  cancel: cancelIcon,
  caretLeft: caretAltLeftIcon,
  caretRight: caretAltRightIcon,
  check: checkIcon,
  checkboxNull: checkboxNullIcon,
  chevronDown: chevronDownIcon,
  chevronLeft: chevronLeftIcon,
  chevronRight: chevronRightIcon,
  chevronUp: chevronUpIcon,
  close: xIcon,
  copy: copyIcon,
  download: downloadIcon,
  edit: pencilIcon,
  editTools: editToolsIcon,
  excel: fileExcelIcon,
  export: exportIcon,
  filePdf: filePdfIcon,
  filterClear: filterClearIcon,
  folderOpen: folderOpenIcon,
  fullscreen: fullscreenIcon,
  home: homeIcon,
  hyperlinkOpen: hyperlinkOpenIcon,
  info: infoCircleIcon,
  mapMarker: mapMarkerIcon,
  menu: menuIcon,
  minus: minusIcon,
  minusCircle: minusCircleIcon,
  more: moreHorizontalIcon,
  note: stickyNoteIcon,
  paste: pasteSparkleIcon,
  plus: plusIcon,
  plusCircle: plusCircleIcon,
  publish: hyperlinkOpenIcon,
  questionSolid: questionSolidIcon,
  redo: redoIcon,
  refresh: arrowsRotateOutlineIcon,
  reorder: reorderIcon,
  reset: arrowRotateCcwIcon,
  resetClock: clockArrowRotateIcon,
  save: saveIcon,
  search: searchIcon,
  settings: gearIcon,
  start: gearsIcon,
  swap: arrowsSwapIcon,
  tableColumnInsertLeft: tableColumnInsertLeftIcon,
  tableRowInsertAbove: tableRowInsertAboveIcon,
  trash: trashIcon,
  undo: undoIcon,
  upload: uploadIcon,
  user: userIcon,
  warning: warningTriangleIcon,
  window: windowIcon,
  x: xIcon,
  xCircle: xCircleIcon,
  zoom: zoomSparkleIcon,
  zoomIn: zoomInIcon,
  zoomOut: zoomOutIcon,
} satisfies Record<string, SVGIcon>;
